export default __webpack_public_path__ + "static/media/jo_preto.3aa68710.png";